import { i18n, TFunction } from 'i18next';

import { areaIcons } from '@/constants/areaIcons';
import { uiIcons } from '@/constants/uiIcons';
import { capitalize, kebabToPascal } from '@/legacy/utils/string/string';

export const getActionNameTranslation = (
  actionKey: string,
  fallback: string,
  i18n: i18n,
  t: TFunction,
) => {
  if (!actionKey) return fallback;

  const translationKey = `${kebabToPascal(actionKey)}Label`;

  const actionTranslationExists = i18n.exists(`searchModal:${translationKey}`);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return actionTranslationExists ? t(translationKey as any) : fallback;
};

export const getCollectionLabelTranslation = (
  collectionName: string,
  i18n: i18n,
  t: TFunction,
) => {
  if (!collectionName) return '';

  const translationKey = `Collection${capitalize(collectionName)}Label`;

  const collectionTranslationExists = i18n.exists(
    `searchModal:${translationKey}`,
  );

  return collectionTranslationExists
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      t(translationKey as any)
    : collectionName;
};

export const getCollectionLabelIcon = (collectionName: string) => {
  switch (collectionName) {
    case 'projects':
      return areaIcons.projects || '';
    case 'customers':
      return areaIcons.customers || '';
    case 'employees':
      return areaIcons.employees || '';
    case 'invoices':
      return areaIcons.invoices || '';
    case 'reports':
      return areaIcons.reports || '';
    case 'actions':
      return uiIcons.actions.add || '';
    case 'contacts':
      return areaIcons.contacts || '';
    case 'dashboards':
      return areaIcons.dashboards || '';
    default:
      return '';
  }
};

export const getHighlightFieldLabelTranslation = (
  highlightFieldName: string,
  i18n: i18n,
  t: TFunction,
) => {
  if (!highlightFieldName) return '';

  const translationKey = `${capitalize(highlightFieldName)}FieldLabel`;

  const highlightFieldTranslationExists = i18n.exists(
    `searchModal:${translationKey}`,
  );

  return highlightFieldTranslationExists
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      `${t(translationKey as any)}: `
    : `${highlightFieldName}: `;
};
